/**
 * Preset System
 *
 * Save/load full design state snapshots to localStorage.
 * Ported from legacy.html lines 3593-3640.
 */

const STORAGE_KEY = 'stencil-presets';

export function getPresets() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

export function savePreset(name, snapshot) {
  const presets = getPresets();
  presets[name] = snapshot;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(presets));
}

export function loadPreset(name) {
  return getPresets()[name] || null;
}

export function deletePreset(name) {
  const presets = getPresets();
  delete presets[name];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(presets));
}

export function listPresets() {
  return Object.keys(getPresets());
}
